'use client'

import { createInstance } from '@/i18n/create.instance'
import { i18nConfig } from '@/i18n/i18n.config'
import { init } from '@/i18n/init'
import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { useTranslation as useTranslationOrg } from 'react-i18next'

const runsOnServerSide = typeof window === 'undefined'

const instance = createInstance()
void init(instance, {
  preload: false,
})

export function useTranslation(
  lng?: string,
  ns: string | string[] = i18nConfig.defaultNS,
  options: { keyPrefix?: string } = {},
) {
  const [cookies, setCookie] = useCookies([i18nConfig.cookieName])
  const ret = useTranslationOrg(ns, options)

  const { i18n } = ret

  if (runsOnServerSide && lng && i18n.resolvedLanguage !== lng) {
    void i18n.changeLanguage(lng)
  } else {
    const [activeLng, setActiveLng] = useState(i18n.resolvedLanguage)

    useEffect(() => {
      if (activeLng === i18n.resolvedLanguage) {
        return
      }

      setActiveLng(i18n.resolvedLanguage)
    }, [activeLng, i18n.resolvedLanguage])

    useEffect(() => {
      if (!lng || i18n.resolvedLanguage === lng) {
        return
      }

      void i18n.changeLanguage(lng)
    }, [lng, i18n])

    useEffect(() => {
      if (cookies.i18next === lng) {
        return
      }

      setCookie(i18nConfig.cookieName, lng, { path: '/' })
    }, [lng, cookies.i18next])
  }

  return ret
}
